import { render, staticRenderFns } from "./RecepcionEquipos.vue?vue&type=template&id=244f6f16&"
import script from "./RecepcionEquipos.vue?vue&type=script&lang=ts&"
export * from "./RecepcionEquipos.vue?vue&type=script&lang=ts&"
import style0 from "./RecepcionEquipos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports